﻿export class Http404Interceptor implements angular.IHttpInterceptor {
    public static factory($q: ng.IQService): Http404Interceptor {
        return new Http404Interceptor($q);
    }

    constructor(private $q: ng.IQService) {}

    private noResourceKey: string = 'idi-nosuchresource';

    public responseError = (response: any): any => {
        if (response.status === 404 && this.noResourceKey in response.headers()) {
            response.status = 204;
            return response;
        }
        return this.$q.reject(response);
    }


}

Http404Interceptor.factory.$inject = ['$q'];